export const noninputkeys = ['Dead', 'Unidentified']; // TODO: Include shift, alt etc here? Rename the thing?
export const Backspace = 'Backspace';
export const Delete = 'Delete';
export const deleteKeys = [Backspace, Delete];

/**
 * Contains a list of common keys that are used in keyboard events that we normally dont need to filter out
 * @description This is keys like Enter, Arrow keys, Delete, Backspace, Tab, Ctrl and clipboard keys
 * @param event
 */
export function isCommonKey(event: KeyboardEvent): boolean {
    if (!event || !event.key) return false;

    // We always assume CTRL is NOT a common key since it is used in many shortcuts
    if (event.ctrlKey || event.metaKey) {
        return false;
    }

    if (
        event.key == 'Delete' ||
        event.key == 'Backspace' ||
        event.key == 'ArrowLeft' ||
        event.key == 'ArrowRight' ||
        event.key == 'ArrowUp' ||
        event.key == 'ArrowDown' ||
        event.key == 'Tab' ||
        event.key == 'Escape' ||
        event.key == 'Enter' ||
        event.key == 'End'
    ) {
        return true;
    }

    // If the key is more than one character we assume it is a special key.
    if (event.key.length > 1) {
        return true;
    }

    return false;
}

/**
 * This is keys that are used to determine when we are done editing an input field
 * @param event
 * @returns
 */
export function isInputFinishedKey(event: KeyboardEvent): boolean {
    if (event.key == 'Enter' || event.key == 'Tab') {
        return true;
    }

    return false;
}
